export const demoTemplates = [
  {
    templateID: '7e15015c-cf37-42b5-b87e-ab3311b24673',
    templateName: 'Sample Marketing Coupon',
    templateDescription: 'One template setup to accommodate four different products, two different layouts, and infinite options.',
    templateFields: [
      {
        name: 'Product',
        label: 'Product',
        type: 'select',
        options: [
          { value: 'iron', label: 'Iron' },
          { value: 'blender', label: 'Blender' },
          { value: 'vacuum', label: 'Vacuum' }
        ],
        required: true
      },
      {
        name: 'Offer',
        label: 'Offer Amount',
        type: 'string',
        placeholder: 'E.g. 20% OFF',
        defaultValue: '20% OFF',
        required: true
      },
      {
        name: 'Price',
        label: 'Price',
        type: 'string',
        placeholder: 'E.g. $25',
        defaultValue: '$25',
        required: true
      },
      {
        name: 'Expiry Date',
        label: 'Expiry Date',
        type: 'date',
        // Set default to today's date in YYYY-MM-DD format
        defaultValue: new Date().toISOString().split('T')[0],
        required: true
      },
      {
        name: 'Color',
        label: 'Color Scheme',
        type: 'select',
        options: [
          { value: 'red', label: 'Red' },
          { value: 'blue', label: 'Blue' },
          { value: 'green', label: 'Green' },
          { value: 'orange', label: 'Orange' }
        ],
        defaultValue: 'red',
        required: true
      },
      {
        name: 'Switch Sides',
        label: 'Switch Sides',
        type: 'boolean',
        description: 'Toggle to reverse the layout of the coupon',
        defaultValue: false,
        required: false
      }
    ]
  },
  {
    templateID: '965be4db-3ddb-4e3e-8a25-ef4caea45168',
    templateName: 'Coffee Machine Brochure',
    templateDescription: 'Personalised and versioned brochure for coffee machines.',
    templateFields: [
      {
        name: 'First Name',
        label: 'First Name ',
        type: 'string',
        placeholder: 'David',
        defaultValue: 'David',
        required: true
      },
      {
        name: 'Machine',
        label: 'Machine',
        type: 'select',
        options: [
          { value: 'AK-1000', label: 'AK-1000' },
          { value: 'BL-100', label: 'BL-100' }
        ],
        defaultValue: 'AK-1000',
        required: true
      },      
      {
        name: 'Color',
        label: 'Color Scheme',
        type: 'select',
        options: [
          { value: 'Black', label: 'Black' },
          { value: 'Blue', label: 'Blue' },
          { value: 'Green', label: 'Green' },
          { value: 'Brown', label: 'Brown' }
        ],
        defaultValue: 'Black',
        required: true
      }

    ]
  },
{
    templateID: 'aacaf43f-1ce0-470d-bfc5-76b19fe4bf7e',
    templateName: '4th July Card',
    templateDescription: 'Personalised and versioned card for the 4th of July.',
    templateFields: [
      {
        name: 'To Name',
        label: 'Sender Name',
        type: 'string',
        placeholder: 'David',
        defaultValue: 'David',
        required: true
      },
      {
        name: 'From Name',
        label: 'Recipient Name',
        type: 'string',
        placeholder: 'Harry',
        defaultValue: 'Harry',
        required: true
      },
      {
        name: 'Message',
        label: 'Message',
        type: 'string',
        placeholder: 'Experience the power of Personalia. Enjoy!',
        defaultValue: 'Experience the power of Personalia. Enjoy!',
        required: true
      },    
      {
        name: 'Show Logo',
        label: 'Show Logo',
        type: 'boolean',
        description: 'Toggle to show or hide the logo',
        defaultValue: true,
        required: false
      },  
      {
        name: 'Logo Type',
        label: 'Logo',
        type: 'select',
        options: [
          { value: 'Personalia', label: 'Personalia' },
          { value: 'XMPie', label: 'XMPie' }
        ],
        defaultValue: 'XMPie',
        required: true
      },  
      {
        name: 'Image',
        label: 'Style',
        type: 'select',
        options: [
          { value: 'Fun ', label: 'Fun' },
          { value: 'Formal', label: 'Formal' },
          { value: 'Family', label: 'Family' }
        ],
        defaultValue: 'Fun',
        required: true
      },
      {
        name: 'Photo URL',
        label: 'Image',
        type: 'string',
        placeholder: 'fetch:https://help.xmpie.com/images/Fireworks.jpg',
        defaultValue: '',
        required: false
      }

    ]
  }
  // We can add more templates here in the future
];
